module.exports = __webpack_public_path__ + "img/icon_st07.672f703d.png";